import { Button, Dialog, DialogContent, DialogActions, Typography } from "@mui/material"
import { useState } from "react"
import { Form, useNotify, useRefresh, useTranslate } from "react-admin"
import { useMutation } from "react-query";
import { RemoveLogoCommand } from "../GeneratedClients/FreeBillApi";
import { apiService } from "../apiService";

const RemoveLogoDialog = () => {

  const translate = useTranslate()
  const [open, setOpen] = useState<boolean>(false)
  const notify = useNotify()
  const refresh = useRefresh()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const { mutate, isLoading } = useMutation((command: RemoveLogoCommand) => 
    apiService.UsersApi.removeLogo({removeLogoCommand: command, id: command.userId!}),
    {
      onSuccess: () => {
        notify('Logo gelöscht')
        refresh()
        handleClose()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleSubmit = async (event: any)  => {
    const id = event.logo.id
    const userId = event.id
    const command: RemoveLogoCommand = {id: id, userId: userId}
    mutate(command)
  }

  return (
    <>
      <Button onClick={handleClickOpen} color="error">{translate("resources.logo.removeLogo")}</Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <DialogContent>
            <Typography variant="body2">{translate("ra.message.are_you_sure")}</Typography>
          </DialogContent>
          <DialogActions>
            <Button type='submit' disabled={isLoading} color="error">{translate("ra.action.delete")}</Button>
            <Button onClick={handleClose}>{translate("ra.action.cancel")}</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  )
}

export default RemoveLogoDialog